import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';

// STYLES
import { ShowMovieVotesDetailsStyled } from './styles';

const MAX_SHOW_LENGTH = 10;

function ShowMovieVotesDetails({ title, peopleList }) {
  const [t] = useTranslation();

  const overflowItemsLength = peopleList.length - MAX_SHOW_LENGTH;
  const hasOverflowItems = overflowItemsLength > 0;
  const reducedPeopleList = hasOverflowItems ? peopleList.slice(0, MAX_SHOW_LENGTH) : peopleList;

  return (
    <ShowMovieVotesDetailsStyled>
      <Typography variant="h6" component="h6" className="votes-details__title">
        {title}
      </Typography>
      <Grid container direction="column">
        {reducedPeopleList.map((name, idx) => (
          <Grid item key={idx}>
            <Typography className="p4">{name}</Typography>
          </Grid>
        ))}
        {hasOverflowItems && (
          <Grid item>
            <Typography className="p4">
              {`${t('common.andMore', { count: overflowItemsLength })}...`}
            </Typography>
          </Grid>
        )}
      </Grid>
    </ShowMovieVotesDetailsStyled>
  );
}

ShowMovieVotesDetails.propTypes = {
  title: PropTypes.string.isRequired,
  peopleList: PropTypes.array.isRequired,
};

export default React.memo(ShowMovieVotesDetails);
